// extracted by mini-css-extract-plugin
export default {"itemWrapper":"ContentList_itemWrapper__Ynqsj","loaderWrapper":"ContentList_loaderWrapper__6pi+0"};